import useUniversalStore from "store/universalStore";
import React, { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";

const MonthView = ({ setAnimation }) => {
  const { write, selectedMonth } = useUniversalStore((state) => state);
  const currDate = new Date();
  const [showCalendar, setShowCalendar] = useState(false);
  const [nextMonthAccessible, setNextMonthAccessible] = useState(false);
  const calendarRef = useRef(null); // Reference for calendar popup
  const month_name = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  useEffect(() => {
    const year = selectedMonth.getFullYear();
    const month = selectedMonth.getMonth();
    console.log("Month changing");

    if (month === currDate.getMonth() && year === currDate.getFullYear()) {
      setNextMonthAccessible(false);
    } else {
      setNextMonthAccessible(true);
    }
  }, [selectedMonth]);

  // Close the calendar if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDateChange = (newDate) => {
    setShowCalendar(false);

    // Update the month in the parent component
    write({ selectedMonth: newDate });
    // handleNewDate(newDate);
  };

  const addMonth = () => {
    if (nextMonthAccessible) {
      const newDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 1);
      handleDateChange(newDate);
      // setDate((prevDate) => new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1));
      setAnimation("animate__animated animate__slideInRight fast-animation");
    }
  };

  const subMonth = () => {
    const newDate = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() - 1, 1);
    handleDateChange(newDate);
    setAnimation("animate__animated animate__slideInLeft fast-animation");
  };

  const isFutureMonth = (month, year) => {
    const currMonth = currDate.getMonth();
    const currYear = currDate.getFullYear();
    return year > currYear || (year === currYear && month > currMonth);
  };

  return (
    <>
      <i className="bi bi-arrow-left-circle-fill fs-4 cursor-pointer"
        onClick={() => subMonth()} />

      <label
        className="fs-4 p-2 cursor-pointer user-select-none"
        onClick={() => setShowCalendar(!showCalendar)}>
        {month_name[selectedMonth.getMonth()] + `'` + selectedMonth.getFullYear()}
      </label>
      {showCalendar && (
        <div className="calendar-popup" ref={calendarRef}>
          <DatePicker
            selected={selectedMonth}
            onChange={handleDateChange}
            maxDate={currDate}
            showMonthYearPicker
            dateFormat="MMM''yyyy"
            inline
          />
        </div>
      )}
      <i disabled={nextMonthAccessible}
        onClick={() => addMonth()}
        className={`fs-4 bi
            ${nextMonthAccessible ? "bi-arrow-right-circle-fill cursor-pointer" : "bi-arrow-right-circle opacity-50"}`}></i>
    </>
  );
};

export default MonthView;
